module.exports = __webpack_public_path__ + "5d0d42cbfedecc835a006cecf4a406e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo-sq.png
// module id = 2560
// module chunks = 0